// frontend/src/landing/sections/SecuritySection.tsx
import Brand from "../components/Brand";
import Card from "../components/Card";
import Section from "../components/Section";

export default function SecuritySection() {
  return (
    <Section id="sicherheit" eyebrow="Betrieb" title="Sicherheit und Datenschutz">
      <p className="zg-text">
        <Brand /> ist konsequent auf zeitgemäße Datenverarbeitung ausgelegt.
      </p>

      <div className="zg-cards">
        <Card title="Cloud-basiert" meta="Europäische Datensouveränität im Rahmen der Initiative Gaia-X" />
        <Card title="DSGVO-konform" meta="ISO/IEC 27001-zertifiziertes Hosting" />
        <Card title="Klima-neutral" meta="Klimaneutraler Betrieb mit 100% erneuerbaren Energien" />
      </div>

    </Section>
  );
}